// 私有化构建会通过流水线修改此文件，请勿代码中修改提交！！！
import { isPrivate as isPrivateFromCommon } from 'src/config/qdAdminCommon';

// 是否是私有化环境
const isPrivate = false || isPrivateFromCommon;
// 是否有发短信能力
const smsAbility = true;
// 私有化项目名
const projectName = '';

export { isPrivate, smsAbility, projectName };
